import { MatriculaFilter } from '../models/matricula-filter';
import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PaginationFilter } from 'path-shared/models/pagination.filter';
import { IFilterService } from 'path-shared/services/datasource/filter-service';
import { CustomFilterService } from 'path-shared/services/datasource/custom-filter-service';
import { MatriculaHistoricFilter } from '../models/matricula-historic-filter';
import { Reflection } from 'path-shared/services/reflection/reflection';

const defaultSortParam = 'tipus';
const defaultSortDirection = 'desc';

@Injectable()
export class MatriculaFilterService extends CustomFilterService {
  public createFilterParams(filter: MatriculaFilter, start: number, pageSize: number, sortField: string, sortDir: string ) {
    return new HttpParams()
    .append('tipus', Reflection.hasValue(filter.tipus) ? filter.tipus : '')
    .append('observacions', filter.observacions ? filter.observacions : '')
    .append('model', filter.model ? filter.model : '')
    .append('matricula', filter.matricula ? filter.matricula : '')
    .append('marca', filter.marca ? filter.marca : '')
    .append('dataInici', filter.dataInici === null ? '' :  typeof(filter.dataInici) === 'string' ?
    filter.dataInici : filter.dataInici.toDateString())
    .append('dataFi', filter.dataFi === null ? '' :  typeof(filter.dataFi) === 'string' ?
    filter.dataFi : filter.dataFi.toDateString())
    .append('start', start.toString())
    .append('size', pageSize.toString())
    .append('sortparam', sortField === undefined ? defaultSortParam : sortField)
    .append('sortdir', sortDir === '' ? defaultSortDirection : sortDir)
    ;
  }

  public createLoadParams(content: string) {
    return new HttpParams()
    .append('content', content ? content : '')
    ;
  }


}
